<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { getErrorTracker, add, ignore } from "@/api/tracker/error";
import { getAgents } from "@/api/order/tracker";
import cTable from "@/base/common/index";
export default {
  name: "trackererror",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getErrorTracker,
        ignore,
        getAgents,
        add
        // getuser,
        // getgoodsInfo
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.awbno = this.$page.selectAll.map(item => {
                return item.awbno;
              });
              this.$page.handleRequestMethods("add", data, true).then(res => {
                this.$page.getList();
                this.close();
              });
            }
          },
          config: {
            title: this.$t("handle"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              content: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ content: 24 }],
          fields: [
            {
              name: this.$t("handling_opinions"),
              key: "content",
              component: "Input",
              // formItemBind: {
              //   required: true,
              //   message: "cannot be empty"
              // },
              bind: {
                type: "textarea",
                autosize: { minRows: 2, maxRows: 6 }
              }
            },
            {
              name: this.$t("handling_opinions"),
              key: "content",
              component: "Input",
              // formItemBind: {
              //   required: true,
              //   message: "cannot be empty"
              // },
              bind: {
                type: "textarea",
                autosize: { minRows: 2, maxRows: 6 }
              }
            }
          ]
        },
        error: {
          methods: {
            ok({ row, close }) {
              // let data = row;
              this.$page.handleRequestMethods("ignore", row, true).then(res => {
                this.$page.getList();
                this.close();
              });
            }
          },
          config: {
            title: "ignore_error",
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              agent: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              error: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ agent: 24 }, { error: 24 }, { remarks: 24 }],
          fields: [
            {
              key: "agent",
              name: () => this.$t("agentName"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("agentName");
              },
              clearable: true,
              options: [],
              config: { label: "agent", value: "agent" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getAgents")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: this.$t("error_mes"),
              key: "error",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2, maxRows: 6 }
              }
            },
            {
              name: this.$t("order_desc"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2, maxRows: 6 }
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "agent",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            clearable: true,
            options: [],
            config: { label: "agent", value: "agent" }
          },
          {
            key: "is_process",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("process_status");
            },
            clearable: true,
            options: [
              {
                label: this.$t("y_process"),
                value: "YES"
              },
              {
                label: this.$t("n_process"),
                value: "NO"
              }
            ]
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
            }
          },
          {
            key: "errorContent",
            placeholder() {
              return this.$t("error_mes");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
            }
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: this.$t("handle"),
              type: "add",
              fnName: "add",
              bind: {
                type: "warning"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: this.$t("ignore_error"),
              type: "error",
              fnName: "error",
              bind: {
                type: "success"
              }
              // disabled: row => {
              //   return row.searchForm.agent ? false : true;
              // }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open();
            },
            error({ file, searchForm }) {
              this.getModal("error").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: this.$t("order_number"),
          key: "awbno",
          align: "left",
          tooltip: true,
          width: 130
        },
        {
          name: this.$t("agentName"),
          key: "agent",
          align: "left",
          tooltip: true,
          width: 100
        },
        {
          name: this.$t("order_refCode"),
          key: "agent_refer",
          align: "left",
          tooltip: true,
          width: 100
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: this.$t("error_mes"),
          key: "error",
          align: "left",
          tooltip: true,
          minWidth: 100
          // children: [
          //   { name: "name", key: "error" },
          //   { name: "123", key: "123" }
          // ]
        },
        {
          name: this.$t("handler"),
          key: "staffName",
          align: "left",
          tooltip: true,
          width: 100
        },
        {
          name: this.$t("handling_opinions"),
          key: "content",
          align: "left",
          tooltip: true,
          width: 150
        },
        {
          name: this.$t("processing_time"),
          key: "operation_time",
          align: "center",
          tooltip: true,
          width: 170
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: this.$t("createTime"),
          key: "create_time",
          align: "center",
          tooltip: true,
          width: 170
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        }
      ]
    };
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "agent") item.options = (await getAgents()).data.payload;
    });
  }
};
</script>
